import { render, staticRenderFns } from "./VolunteerProfileDetails.vue?vue&type=template&id=fa46c5ec&scoped=true"
import script from "./VolunteerProfileDetails.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./VolunteerProfileDetails.vue?vue&type=style&index=0&id=fa46c5ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa46c5ec",
  null
  
)

export default component.exports